export default __webpack_public_path__ + "static/media/gitbook.739790c1.svg";